import { createModule } from './vuexok';
import activityStore from './activity';
import activityTypingStore from './activity/typing';
import applicationStore from './application';
import errorStore from './error';
import keyboardStore from './keyboard';
import studentStore from './student';
import accessibilityStore from './accessibility';
import omit from 'lodash/omit';
export const activity = createModule('activity', omit(activityStore, 'modules'));
export const activityTyping = createModule('activity/typing', activityTypingStore);
export const keyboard = createModule('keyboard', keyboardStore);
export const error = createModule('error', errorStore);
export const application = createModule('application', applicationStore);
export const student = createModule('student', studentStore);
export const accessibility = createModule('accessibility', accessibilityStore);
export function mapState(obj, paths) {
    const ret = Object.create(null);
    if (Array.isArray(paths)) {
        for (const k of paths) {
            ret[k] = () => { var _a; return (_a = obj.state) === null || _a === void 0 ? void 0 : _a[k]; };
        }
    }
    else if (typeof paths === 'object') {
        for (const k in paths) {
            if (typeof paths[k] === 'function') {
                ret[k] = () => paths[k](obj.state);
            }
            else {
                ret[k] = () => obj.state[paths[k]];
            }
        }
    }
    return ret;
}
export function mapActions(obj, paths) {
    const ret = Object.create(null);
    for (const k of paths) {
        ret[k] = obj.actions[k];
    }
    return ret;
}
export function mapMutations(obj, paths) {
    const ret = Object.create(null);
    for (const k of paths) {
        ret[k] = obj.mutations[k];
    }
    return ret;
}
export function mapGetters(obj, paths) {
    const ret = Object.create(null);
    if (Array.isArray(paths)) {
        for (const k of paths) {
            ret[k] = () => obj.getters[k];
        }
    }
    else if (typeof paths === 'object') {
        for (const k in paths) {
            ret[k] = () => obj.getters[paths[k]];
        }
    }
    return ret;
}
